var React = require('react');

function Lightning (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("circle",{"cx":"140.983","cy":"141.003","r":"141","fill":"#7B1AF7","key":0}),React.createElement("path",{"d":"M79.7609 144.047L173.761 63.0466C177.857 60.4235 181.761 63.0466 179.261 67.5466L149.261 126.547H202.761C202.761 126.547 211.261 126.547 202.761 133.547L110.261 215.047C103.761 220.547 99.261 217.547 103.761 209.047L132.761 151.547H79.7609C79.7609 151.547 71.2609 151.547 79.7609 144.047Z","fill":"white","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"282","height":"282","fill":"white"})))]);
}

Lightning.defaultProps = {"width":"282","height":"282","viewBox":"0 0 282 282","fill":"none"};

module.exports = Lightning;

Lightning.default = Lightning;
